import { api as API, Predicates } from 'prismic-javascript'
import ApiSearchResponse from 'prismic-javascript/d.ts/ApiSearchResponse'

const apiEndpoint = 'https://cinch.prismic.io/api/v2'

const tidyResponse = (response: ApiSearchResponse) => {
  return response.results.map(({ uid: id, data: { question: title, summary: subtitle } }) => ({
    id,
    title,
    subtitle,
  }))
}

type Search = (searchTerm: string, setResults: React.Dispatch<React.SetStateAction<any[]>>) => Promise<unknown>

const search: Search = (searchTerm, setResults) => {
  return new Promise((resolve) => {
    API(apiEndpoint).then((api) => {
      api
        .query([Predicates.at('document.type', 'jargon'), Predicates.fulltext('document', searchTerm)], {})
        .then((response) => {
          const results = tidyResponse(response)

          setResults(results)

          return resolve(results)
        })
    })
  })
}

export default search
